import injectSheet from 'react-jss';

import { ReviewsList as _ReviewsList, ReviewsListProps } from './ReviewsList';
import { styles } from './styles';

export const ReviewsList = injectSheet<ReviewsListProps>(styles)(_ReviewsList);
